import PropTypes from 'prop-types';

const EmployeeType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  picture_url: PropTypes.string,
  position: PropTypes.string,
  primary_phone: PropTypes.string,
  primary_phone_type: PropTypes.string,
  role: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  pending: PropTypes.bool,
  workrooms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
  assignable: PropTypes.bool.isRequired,
});

export default EmployeeType;



// WEBPACK FOOTER //
// ./client/app/shared/types/employee.js